/* Global imports. */
import React from "react";
import HTMLReactParser from "html-react-parser";

/* Component imports. */
import Download from "@components/Download";

/* Model imports. */
import { KontentDownload, KontentImprint } from "@models/kontent";

interface Props {
  title?: string;
  subtitle?: string;
  subcopy?: string;
  buttonText?: string;
  buttonLink?: string;
  resources: Array<{ elements: KontentDownload }>;
  relatedContributors?: string;
  relatedISBNs?: string;
  relatedSeries?: string;
  imprints?: Array<KontentImprint>;
  componentID?: string;
}

const FeaturedResources = ({
  title,
  subtitle,
  subcopy,
  buttonText,
  buttonLink,
  resources,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  relatedContributors,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  relatedISBNs,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  relatedSeries,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  imprints,
  componentID
}: Props) => (
  <section id={componentID} data-component="featured-resources">
    <div>
      {(title || subtitle || subcopy) && (
        <div className="text-center">
          {title && <h3>{title}</h3>}
          {subtitle && <h4>{subtitle}</h4>}
          {subcopy && subcopy !== "<p><br></p>" && <div>{HTMLReactParser(subcopy)}</div>}
        </div>
      )}
      <ul className="grid items-start grid-cols-1 sm:grid-cols-2 md:grid-cols-4 sm:gap-x-8 !pl-0 !list-none">
        {resources &&
          resources.map((download: { elements: KontentDownload }) => (
            <li>
              <Download
                title={download.elements.title.value}
                description={download.elements.description.value}
                resource={download.elements.resource.value[0]}
                image={download.elements.image.value[0]}
                buttonText={download.elements.button_text.value}
                hasKeyline={true}
              />
            </li>
          ))}
      </ul>
      {buttonText && buttonLink && (
        <div className="text-center">
          <a className="button" href={buttonLink}>
            {buttonText}
          </a>
        </div>
      )}
    </div>
  </section>
);

export default FeaturedResources;
